import { render, staticRenderFns } from "./UpdateDirectorName.vue?vue&type=template&id=733373a1&scoped=true"
import script from "./UpdateDirectorName.vue?vue&type=script&lang=js"
export * from "./UpdateDirectorName.vue?vue&type=script&lang=js"
import style0 from "./UpdateDirectorName.vue?vue&type=style&index=0&id=733373a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733373a1",
  null
  
)

export default component.exports